export default "__VITE_ASSET__CiEDJEap__"